import { render, staticRenderFns } from "./MovementDocument.vue?vue&type=template&id=a9219d52&"
import script from "./MovementDocument.vue?vue&type=script&lang=js&"
export * from "./MovementDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports